<template>
    <div>
        <div class="expandable-table-header" :class="{ 'expanded': show_table }"
            v-if="Object.keys(relation_info_table_data).length > 0" @click="show_table = !show_table">
            <div class="header-content">
                <div class="header-icon">
                    <font-awesome-icon v-if="!show_table" :icon="['fas', 'chevron-down']" title="Razširi pogled" />
                    <font-awesome-icon v-else :icon="['fas', 'chevron-up']" title="Skrči pogled" />
                </div>
                <div class="header-text">
                    <span class="header-title">Načrtovane aktivnosti v preteklem obdobju</span>
                    <span class="header-subtitle">Kliknite za prikaz podatkov</span>
                </div>
                <div class="header-indicator">
                    <font-awesome-icon v-if="!show_table" :icon="['fas', 'angle-down']" />
                    <font-awesome-icon v-else :icon="['fas', 'angle-up']" />
                </div>
            </div>
        </div>

        <div v-show="show_table" class="table_static_data" style="margin-top: 10px;">
            <table v-if="relation_info_table_data.detail">
                <thead>
                    <tr>
                        <th v-for="(column, key) of relation_info_table_data.detail" :key="key">
                            {{ column.name }}
                        </th>
                        <th class="short_column">
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, key) of relation_info_table_data.data" :key="key">
                        <td v-for="(value, key) of row" :key="key">
                            {{ value }}
                        </td>
                        <td class="short_column">
                            <div :class="cell_text_exists(row) ? 'icon disabled' : 'icon'"
                                :title="cell_text_exists(row) ? 'V tabeli že obstaja vrstica z istimi podatki' : 'Prenesi vrstico v tabelo'"
                                @click="!cell_text_exists(row) && clone_row_in_table(key)">
                                <font-awesome-icon :icon="['fas', 'circle-down']" />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>


<script>
import { mapActions } from 'vuex';

export default {
    name: 'SectionsDetailRelationInfoTables',
    components: {
    },
    data: function () {
        return {
            show_table: false,
        }
    },
    computed: {
        relation_info_table_data() {
            return this.$store.getters.subsections_relation_info_table_data[this.active_subsection_id];
        },
        active_subsection_id() {
            return this.$store.getters.active_subsection_id;
        },

        // Get main table data to compare against
        main_table_data() {
            return this.$store.getters.subsection_data.data || {};
        },

        // Get main table columns to find the first column ID
        main_table_columns() {
            return this.$store.getters.subsection_data.columns || {};
        }
    },
    methods: {
        ...mapActions([
            'cloneRowInSubsectionTable'
        ]),

        // Disable copy if some main-table row already contains ALL non-empty values
        // from this relation row (same row, any columns — position-agnostic).
        // So two relation rows sharing only the first column stay independent.
        cell_text_exists(row) {
            if (typeof row !== 'object' || row === null) {
                return false;
            }

            const relationValues = Object.keys(row)
                .sort((a, b) => parseInt(a) - parseInt(b))
                .map(k => row[k])
                .filter(v => v !== '' && v != null);

            if (!relationValues.length) {
                return false;
            }

            for (let rowId in this.main_table_data) {
                const mainTableRow = this.main_table_data[rowId];
                if (!mainTableRow) {
                    continue;
                }

                const cellValues = Object.values(mainTableRow).map(cell => {
                    if (typeof cell === 'object' && cell && cell.name) {
                        return cell.name;
                    }
                    return cell;
                });

                const allPresent = relationValues.every(v => cellValues.includes(v));
                if (allPresent) {
                    return true;
                }
            }

            return false;
        },

        clone_row_in_table(row_id) {
            let payload = { row_id: row_id, subsection_id: this.active_subsection_id };
            this.cloneRowInSubsectionTable(payload);
        }
    },
    created() {
    }
}
</script>


<style lang="scss" scoped></style>